<template>
  <div class="dev-information">
    <el-row>
      <el-col :span="24">
        <h1 class="news-title">适配多样化智能设备</h1>
      </el-col>
    </el-row>
    <!-- 轮播区域开始 -->
    <div class="dev-swiper-wrapper">
      <!-- 把触摸事件绑定到容器上 -->
      <div
        class="custom-swiper"
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
      >
        <div
          v-for="(item, idx) in items"
          :key="item.id"
          class="news-swiper-slide"
          :class="{
            center: idx === currentIndex,
            left: idx === leftIndex,
            right: idx === rightIndex,
          }"
          v-show="[leftIndex, currentIndex, rightIndex].includes(idx)"
        >
          <el-card shadow="hover" class="news-card" style="cursor: pointer">
            <img
              :src="item.image ? item.image.split(',')[0] : ''"
              class="dev-image"
            />
            <div class="title">{{ item.title }}</div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 轮播区域结束 -->
  </div>
</template>

<script>
import { listByTYpe } from "@/api/news.js";
import { IMG_BASE_URL } from "@/utils/index.js";

export default {
  name: "NewsInformation",
  data() {
    return {
      currentIndex: 0,
      timer: null,
      touchStartX: 0,
      touchEndX: 0,
    };
  },
  watch: {
    // 监听 URL 的变化
    "$route.fullPath": {
      immediate: true,
      handler() {
        this.currentIndex = 0;
      },
    },
  },
  computed: {
    items() {
      const source = this.$route.query.source;
      if (source == "product_lie_11") {
        return [
          {
            image: "https://hr2.chnsoft.com.cn/img/智能航空站系列.png",
            title: "固定智能航空站",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/应急处置机器人.png",
            title: "陆空协同无人车",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/水上智能航空站.png",
            title: "海空协同无人船",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/移动航空站.png",
            title: "无人装备指挥车",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/大载重机场2.png",
            title: "大载重自动机场",
            description: "",
          },
        ];
      } else {
        return [
          {
            image: "https://hr2.chnsoft.com.cn/img/应急处置机器人.png",
            title: "应急处置机器人",
            description: "",
          },
          {
            image:
              "https://hr2.chnsoft.com.cn/img/压缩空气泡沫智能消防车@1x.png",
            title: "无人消防车",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/D51.png",
            title: "集群式换电航站",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/VF7.png",
            title: "垂起固定翼机场",
            description: "",
          },
          {
            image: "https://hr2.chnsoft.com.cn/img/移动航空站.png",
            title: "移动航空站",
            description: "",
          },
        ];
      }
    },
    IMG_BASE_URL() {
      return IMG_BASE_URL;
    },
    leftIndex() {
      const len = this.items.length;
      return (this.currentIndex - 1 + len) % len;
    },
    rightIndex() {
      const len = this.items.length;
      return (this.currentIndex + 1) % len;
    },
  },
  methods: {
    prevSlide() {
      const len = this.items.length;
      this.currentIndex = (this.currentIndex - 1 + len) % len;
      this.restartAutoPlay();
    },
    nextSlide() {
      const len = this.items.length;
      this.currentIndex = (this.currentIndex + 1) % len;
      this.restartAutoPlay();
    },
    goToSlide(idx) {
      this.currentIndex = idx;
      this.restartAutoPlay();
    },
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    restartAutoPlay() {
      this.stopAutoPlay();
      // this.startAutoPlay();
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchEndX = this.touchStartX; // 初始化
    },
    onTouchMove(e) {
      this.touchEndX = e.touches[0].clientX;
    },
    onTouchEnd(e) {
      const deltaX = this.touchEndX - this.touchStartX;
      if (Math.abs(deltaX) > 30) {
        if (deltaX > 0) {
          this.prevSlide();
        } else {
          this.nextSlide();
        }
      }
      // 重置
      this.touchStartX = 0;
      this.touchEndX = 0;
    },
  },
  mounted() {
    const el = this.$el.querySelector(".custom-swiper");
    if (el) {
      el.addEventListener("touchmove", this.onTouchMove, { passive: false });
    }
  },
  beforeDestroy() {
    this.stopAutoPlay();
    const el = this.$el.querySelector(".custom-swiper");
    if (el) {
      el.removeEventListener("touchmove", this.onTouchMove);
    }
  },
};
</script>

<style lang="scss" scoped>
.dev-information {
  width: 100%;

  margin: 0 auto;
  text-align: center;
  /* padding: 16PX 0PX; */
  background-color: #fff;
}

.news-title {
  font-size: 24px;
  margin: 50px 0px 30px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0px;

  font-variation-settings: "opsz" auto;
  color: #1e242a;
}

/* 新增swiper样式 */
.dev-swiper-wrapper {
  width: 100%;
  margin: 0 auto 40px auto;
  overflow: visible;
}

.custom-swiper {
  position: relative;
  width: 100%;
  height: 208px;
  display: flex;
  align-items: center;
  justify-content: center;

  /* 允许垂直滚动，交由浏览器处理；让横向手势交给 JS 处理 */
  touch-action: pan-y;
  -ms-touch-action: pan-y;
}

.news-swiper-slide {
  position: absolute;
  top: 0;
  bottom: 0;
  transition: all 0.3s;
  opacity: 0;
  pointer-events: none;
  z-index: 1;

  /* 默认隐藏 */
  .title {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: bold;
    line-height: 47px;
    height: 47px;
    letter-spacing: 0px;
    background: #fbfbfb;
    color: #1e242a;
    white-space: nowrap;
  }
}

.news-swiper-slide.center {
  /* left: 20%; */
  /* width: 190PX; */
  width: 50%;
  opacity: 1;
  transform: scale(1);
  z-index: 3;
  pointer-events: auto;
  /* padding: 0px 16PX; */
}

.news-swiper-slide.left {
  left: 0;
  width: calc(25% - 16px);
  opacity: 1;
  transform: scale(1);
  z-index: 2;
  pointer-events: auto;

  ::v-deep .el-card__body {
    padding-left: 0px;
  }
}

.news-swiper-slide.right {
  right: 0;
  width: calc(25% - 16px);
  opacity: 1;
  transform: scale(1);
  z-index: 2;
  pointer-events: auto;
  ::v-deep .el-card__body {
    padding-right: 0px;
  }
}

/* 保证间距10PX */
.news-swiper-slide.center {
  /* margin: 0 16PX; */
}

.news-swiper-slide.left,
.news-swiper-slide.right {
  margin: 0px;
}

.swiper-controls {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 0;
  display: flex;
  justify-content: space-between;
  pointer-events: none;
}

.swiper-arrow {
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  pointer-events: auto;
  user-select: none;
}

.swiper-arrow.left {
  margin-left: 8px;
}

.swiper-arrow.right {
  margin-right: 8px;
}

.swiper-dots {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ccc;
  display: inline-block;
  cursor: pointer;
}

.dot.active {
  background: #1e242a;
}

.dev-image {
  max-width: 100%;
  height: 120px;
  object-fit: cover;

  /* 添加圆角 */
  background-size: cover;
}

.left .dev-image {
  object-position: right;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.right .dev-image {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  object-position: left;
}

.center .dev-image {
  border-radius: 8px;
}

.news-content {
  padding: 20px 0px;
  text-align: left;
}

.news-item-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;
  /* 单行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-item-description {
  font-size: 12px;
  color: #1e242a;
  margin-bottom: 8px;
  /* 单行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-meta {
  font-size: 10px;
  color: #999;
  /* display: flex;
  justify-content: space-between; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.view-more {
  margin-top: 20px;
  margin-bottom: 40px;
}

.view-more a {
  text-decoration: none;
  color: #1e242a;
  font-size: 10px;
}

::v-deep .el-card {
  border: none;
}

.news-swiper-slide,
.news-swiper-slide.center,
.news-swiper-slide.left,
.news-swiper-slide.right {
  height: 208px;
}

::v-deep .el-card__body {
  padding: 16px;
  padding-bottom: 6px;
  background: #fbfbfb;
}

.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}

.main-button {
  position: absolute;
  left: 10px;
  top: 90px;
  background: #cccccc2e;
  width: 33px;
  height: 16px;
  line-height: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  font-size: 7px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;
}

.main-button:hover {
  border-color: #0f6bf6;
  color: #0f6bf6;
}
</style>
